import { useQuery, useMutation } from "@tanstack/react-query";

import { fetchSlackChannels, broadcastToSlack } from "@/lib/api";

export function useSlackChannels() {
  return useQuery({
    queryKey: ["slack-channels"],
    queryFn: fetchSlackChannels,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}

export function useBroadcast() {
  return useMutation({
    mutationFn: ({ channel, message }: { channel: string; message: string }) =>
      broadcastToSlack(channel, message),
  });
}
